import React, { createContext, useState, useEffect } from "react";

export const MediaDisplayContext = createContext();

export const MediaDisplayProvider = ({ children }) => {
  // Load initial display mode from local storage or default to "grid"
  const [displayMode, setDisplayMode] = useState(() => {
    return localStorage.getItem("mediaDisplayMode") || "grid";
  });

  // Update local storage when mode changes
  useEffect(() => {
    localStorage.setItem("mediaDisplayMode", displayMode);
  }, [displayMode]);

  return (
    <MediaDisplayContext.Provider value={{ displayMode, setDisplayMode }}>
      {children}
    </MediaDisplayContext.Provider>
  );
};
